import React, { ComponentType } from 'react'
import { StaticPage } from '../business/static-pages/StaticPage'
import { useTran } from 'src/i18n/useTran'
import { msg } from '../i18n/texts/keys'
import { useTheme } from '../ui/style/useTheme'
import { Heading } from '../ui/text/Heading'
import { css } from '../ui/style/css'
import { ExternalLink } from '../routing/ui/ExternalLink'

const NotFoundPage: ComponentType = () => {
    const t = useTran()
    const th = useTheme()
    const externalLink = '/'

    return (
        <StaticPage title={''}>
            <Heading
                level={2}
                fontSize={th.fontSize.lg}
                css={css`
                    text-align: center;
                    margin-bottom: 1rem;
                    color: ${th.colors.tertiary};
                `}
            >
                {t(msg.ui.notFound.title)}
            </Heading>
            <p
                css={css`
                    font-weight: ${th.fontWeight.bold};
                    text-align: center;
                `}
            >
                {t(msg.ui.notFound.subTitle)}
            </p>
            <div
                css={css`
                    font-weight: ${th.fontWeight.bold};
                    text-align: center;
                    margin-top: 0.5rem;
                    margin-bottom: 1rem;
                `}
            >
                <span>{t(msg.ui.notFound.redirect)}</span>
                <ExternalLink value={externalLink} openInNewTab={false}>
                    <span> {t(msg.ui.notFound.homepage)}</span>
                </ExternalLink>
            </div>
        </StaticPage>
    )
}

export default NotFoundPage
